import Button from '@/components/base/Button';

interface Props {
  title: string;
  text?: string;
  primary: { label: string; href: string };
  secondary?: { label: string; href: string };
}

export default function CtaBanner({ title, text, primary, secondary }: Props) {
  return (
    <section className="px-4 md:px-6 lg:px-20 py-16 md:py-20 lg:py-[112px]">
      <div className="max-w-content mx-auto rounded-[24px] bg-background-200 border border-background-300 px-6 py-12 md:px-16 md:py-20 text-center">
        <h2 className="font-heading text-[30px] md:text-[44px] leading-[1.12] font-medium tracking-tight max-w-2xl mx-auto">{title}</h2>
        {text && <p className="mt-5 text-base md:text-lg leading-[1.6] text-foreground-600 max-w-xl mx-auto">{text}</p>}
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button href={primary.href}>{primary.label} <i className="ri-arrow-right-line" /></Button>
          {secondary && <Button href={secondary.href} variant="ghost">{secondary.label}</Button>}
        </div>
      </div>
    </section>
  );
}